import { UserData } from './account-settings.interfaces'

const DIRT_ON_DIRT = 'dirtondirt'
export const DIRT_ON_DIRT_BASE_URL = 'https://www.dirtondirt.com'

export function userIsMigratedFromDirtOnDirt(userData?: UserData): boolean {
  return userData?.company_migrated_from?.toLowerCase().replace(/\s/g, '') === DIRT_ON_DIRT
}
